import OtherLoginMethods from './OtherLoginMethods';

export default OtherLoginMethods;
